export type ClientRequestKind = 'pos' | 'public';

const FALLBACK_ALPHANUM = 'abcdefghijklmnopqrstuvwxyz0123456789';

function randomFallback(length: number): string {
  let result = '';
  for (let i = 0; i < length; i += 1) {
    const index = Math.floor(Math.random() * FALLBACK_ALPHANUM.length);
    result += FALLBACK_ALPHANUM[index];
  }
  return result;
}

export function generateClientRequestId(kind: ClientRequestKind = 'pos'): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    const uuid = (crypto as Crypto).randomUUID();
    return kind + '-' + uuid;
  }
  const timestamp = Date.now().toString(36);
  return kind + '-' + timestamp + '-' + randomFallback(8);
}
